<template>
  <div class="formate-box">
    <span class="formate-icon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="36.742"
        height="36.743"
        viewBox="0 0 36.742 36.743"
      >
        <path
          d="M36.742-9.953a2.249,2.249,0,0,0-2.192-2.3,2.1,2.1,0,0,0-.664.108L13.019-5.252a2.287,2.287,0,0,0-1.537,2.188V14.5a7.643,7.643,0,0,0-4.593-1.49C3.084,13.011,0,15.581,0,18.752s3.084,5.741,6.889,5.741,6.889-2.571,6.889-5.741V6.121L34.445-.768V9.908a7.643,7.643,0,0,0-4.593-1.49c-3.8,0-6.889,2.571-6.889,5.741S26.048,19.9,29.853,19.9s6.889-2.571,6.889-5.741c0,0,0,0,0-.006ZM6.889,22.2C4.4,22.2,2.3,20.619,2.3,18.752s2.1-3.445,4.593-3.445,4.593,1.577,4.593,3.445S9.379,22.2,6.889,22.2ZM34.445-3.188,13.778,3.7V-3.064h-.039v-.008L34.445-9.908ZM29.853,17.6c-2.489,0-4.593-1.577-4.593-3.445s2.1-3.445,4.593-3.445,4.593,1.577,4.593,3.445S32.342,17.6,29.853,17.6Z"
          transform="translate(0 12.25)"
        />
      </svg>
    </span>
  </div>
</template>
<script>
export default {
  name: 'Mp3SoundViewer',
};
</script>
